/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

import React from 'react';
import { connect } from 'react-redux';
import BasePage from '../../../shared/BasePage';
import PropTypes from 'prop-types';
import { Grid, PanelGroup } from 'react-bootstrap';
import { apiFetch } from '../../../apiClient';
import { apiMap } from '../../../config/constants';
import { documentCheckListQuestionShouldDisplay, findQuestionById } from '../../../utils/AOFormUtils';
import { sumbitApplication, getStatusFile, saveUploadBusiness, skipUploadAction } from '../state/action';
import { updateStep } from '../../CompanyRegistration/state/action';
import AOForm from '../../../shared/AOForm';
import LocalComponent from '../components/';
import paths from '../../../config/path';
import history from '../../../utils/history';
import { trackEvent, setTitle } from '../../../utils';

import '../style/ao-form-review.css';
/* eslint-disable array-callback-return */
class AOFormReviewContainer extends BasePage {
    constructor(props) {
        super(props);
        this.state = {
            ...props.params
        };
        this.dummy = false; //the skip function of upload document
        this.handelInformationItem = this.handelInformationItem.bind(this);
        this.handelUploadItem = this.handelUploadItem.bind(this);
        this.handelSubmitApplication = this.handelSubmitApplication.bind(this);
        this.handelCardItem = this.handelCardItem.bind(this);
        this.onAddAction = this.onAddAction.bind(this);
    }

    componentDidMount() {
        this.switchI18n();
        this.loadNewApplication(this.props);
    }
    componentWillUnmount = () => {
        this.timeInterval && clearInterval(this.timeInterval);
    }

    componentWillReceiveProps(nextProps) {
        this.loadNewApplication(nextProps);
        if (nextProps.selectedLanguage !== this.props.selectedLanguage) {
            this.switchI18n();
        }
    }
    switchI18n = () => {
        apiFetch(apiMap.aoFormReviewI18n)().then((i18n) => {
            this.setState({ i18n });
        }).catch(error => { });
    };
    loadNewApplication = (props) => {
        const { applicationInfo, businessInfo } = props;
        if (applicationInfo && businessInfo) {
            this.getAppAndStatus(props);
            this.getCompanyInitalData(props);
            this.getUploadInitalData(props);
            this.setTimeToGetDocumentId(props);
        }
    }
    updateBissinessApi = (uploadFilesTmp, applicationInfo, businessInfo) => {
        const dataS004 = findQuestionById(applicationInfo, 'S004');
        const questionStatus = {};
        const questionStateTmp = {};
        let isClearTimeOut = true;
        const uploadAllTmp = {
            ...businessInfo.uploadFiles,
            ...uploadFilesTmp
        }
        dataS004.questions.map(question => {
            const { questionIndicator, subQuestions } = question;
            subQuestions.map(subItem => {
                const { questionId, answerType } = subItem;
                const subquestionIndicator = subItem.questionIndicator;
                const isShow = this.SoleTraderUpload(questionId, questionIndicator);
                let isHaveAnswer = true;
                if (!questionStateTmp[questionIndicator]) {
                    questionStateTmp[questionIndicator] = [];
                }
                Object.keys(uploadAllTmp).map(indicate => {
                    const isIndicator = (indicate.indexOf(questionIndicator) > -1);
                    const itemTmp = uploadAllTmp[indicate];
                    if (isShow && itemTmp && (answerType === 6) && ((indicate === subquestionIndicator) || isIndicator)) {
                        const itemStatus = itemTmp.status
                        const apiStatus = ['RECEIVED', 'PROCESSING', 'AV_PROCESSING', 'ANTIVIRUS_PASSED', 'CONVERTED', 'ICCM_PROCESSING', 'SAVE_REQUESTED'];
                        isHaveAnswer = false;
                        if (itemStatus === 'SAVED') {
                            questionStateTmp[questionIndicator].push('2');
                        } else if (apiStatus.indexOf(itemStatus) > -1) {
                            questionStateTmp[questionIndicator].push('1');
                        } else if (itemStatus !== '' && itemStatus !== null) {
                            questionStateTmp[questionIndicator].push('3');
                        } else {
                            questionStateTmp[questionIndicator].push('0');
                        }
                    }
                    if (isIndicator && !uploadAllTmp[subquestionIndicator]) {
                        isHaveAnswer = true;
                    }
                })
                if (isHaveAnswer && isShow && answerType === 6) {
                    questionStateTmp[questionIndicator].push('0');
                }
            })
        })
        //status: 1 File uploaded but not complete;  2 completed;  // 3 File scan failed //4  not complete
        Object.keys(questionStateTmp).map(item => {
            if (questionStateTmp[item].indexOf('3') > -1) {
                questionStatus[item] = '3';
            } else if (questionStateTmp[item].indexOf('1') > -1) {
                questionStatus[item] = '1';
                isClearTimeOut = false;
            } else if (questionStateTmp[item].indexOf('0') > -1 && questionStateTmp[item].indexOf('2') > -1) {
                questionStatus[item] = '4';
            } else if (questionStateTmp[item].indexOf('0') > -1) {
                questionStatus[item] = '0';
            } else {
                questionStatus[item] = '2';
            }
        })
        //如果全部status是SAVED,则停止计时器
        if (isClearTimeOut) clearInterval(this.timeInterval);
        businessInfo.uploadFiles = uploadAllTmp;
        businessInfo.questionStatus = {
            ...businessInfo.questionStatus,
            ...questionStatus
        }
        this.getAppAndStatus({ applicationInfo, businessInfo })
        this.pageUploadStatus({ applicationInfo });
        this.getUploadInitalData(this.props);
        //update business api
        this.props.saveUploadBusiness({
            "uploadFiles": {
                ...uploadFilesTmp
            },
            "questionStatus": {
                ...questionStatus
            }
        });
    }
    SoleTraderUpload = (questionId, indicate) => {
        let isShow = true;
        const threeInthree = ['Q004-002-002', 'Q004-002-003', 'Q004-002-004']
        if (indicate === 'MenuBusinessSoleTraderDocFile') {
            if (this.soleTraderAnswer && this.soleTraderAnswer === 'A004-002-000:001' &&  questionId === 'Q004-002-001') {
                isShow = true;
            } else if (this.soleTraderAnswer && this.soleTraderAnswer === 'A004-002-000:002' && threeInthree.indexOf(questionId) > -1) {
                isShow = true;
            } else {
               isShow = false;
            }
        }
        return isShow;
    }
    getUploadId = (documentIdTmp, applicationInfo, businessInfo) => {
        const { uploadFiles } = businessInfo;
        let uploadFilesTmp = {};
        this.props.getStatusFile(documentIdTmp.join(','))
            .then(res => {
                if (res && res.length > 0 && (JSON.stringify(this.resTmp) !== JSON.stringify(res))) {
                    this.resTmp = res;
                    res.map(result => {
                        Object.keys(uploadFiles).map(item => {
                            if (uploadFiles[item] && uploadFiles[item].documentUploadId === result.documentUploadId) {
                                uploadFilesTmp[item] = {
                                    "name": result.documentName || null,
                                    "documentUploadId": result.documentUploadId || null,
                                    "iccmFileNetId": result.iccmFileNetId || null,
                                    "fileNetId": result.fileNetId || null,
                                    "status": result.status || null,
                                    "type": result.mimeType || null,
                                    "indicator": item || null,
                                    "docUploadRespDateTime": uploadFiles[item].docUploadRespDateTime,
                                    "iccmRespDateTime": result.iccmRespDateTime
                                }
                            }
                        })
                    })
                    this.updateBissinessApi(uploadFilesTmp, applicationInfo, businessInfo);
                }
            })
            .catch(error => {
                clearInterval(this.timeInterval);
            })
    }
    setTimeToGetDocumentId = ({ applicationInfo, businessInfo }) => {
        const { uploadFiles } = businessInfo;
        let documentIdTmp = [];
        let count = 1;
        this.resTmp = {};
        Object.keys(uploadFiles).map(item => {
            if (uploadFiles[item] && uploadFiles[item].status !== 'SAVED' && uploadFiles[item].documentUploadId && uploadFiles[item].documentUploadId !== '') {
                documentIdTmp.push(uploadFiles[item].documentUploadId);
            }
        });
        clearInterval(this.timeInterval);
        if (documentIdTmp && documentIdTmp.length > 0) {
            this.getUploadId(documentIdTmp, applicationInfo, businessInfo);
            this.timeInterval = setInterval(function () {
                count++;
                this.getUploadId(documentIdTmp, applicationInfo, businessInfo);
                if (count > 15) {
                    clearInterval(this.timeInterval);
                }
            }.bind(this), 60000);
        }
    }

    getAppAndStatus = ({ applicationInfo, businessInfo }) => {
        const { questionStatus, companyInfo, answerDetails } = businessInfo;
        const dataS003 = findQuestionById(applicationInfo, 'S003');
        const dataS004 = findQuestionById(applicationInfo, 'S004');
        if (companyInfo) {
            applicationInfo.companyInfo = businessInfo.companyInfo;
        }
        if (answerDetails && answerDetails.BusinessSoleTraderDocFileDocumentType) {
            this.soleTraderAnswer = answerDetails.BusinessSoleTraderDocFileDocumentType
        }
        questionStatus && Object.keys(questionStatus).map(indicate => {
            dataS003.questions.map(item => {
                if (item.questionIndicator === indicate) {
                    item.questionStatus = questionStatus[indicate];
                }
            })
            dataS004.questions.map(item => {
                if (item.questionIndicator === indicate) {
                    item.questionStatus = questionStatus[indicate];
                }
            })
        });
    }
    getCompanyInitalData = (props) => {
        const { completedNum, totalNum, unDonePageArr } = this.pageCompanyStatus(props);
        if (unDonePageArr.length === totalNum) {
            this.setState({
                companyState: 0
            });
        } else if (completedNum === totalNum) {
            this.setState({
                companyState: 2
            });
        } else {
            this.setState({
                companyState: 1,
                isCompanyPanel: true
            });
        }
    };
    getUploadInitalData = (props) => {
        const { allPageArr, donePageArr, unDonePageArr } = this.pageUploadStatus(props);
        const completedNum = donePageArr.length;
        const totalNum = allPageArr.length;
        const unDoneNum = unDonePageArr.length;
        if (this.dummy && !props.isSkipUpload) {
            this.setState({
                uploadState: 2,
                isUploadPanel: false
            });
        } else {
            const uploadFileMandatory = props.businessInfo.questionStatus.uploadFileMandatory;
            if (uploadFileMandatory !== 'N') {
                this.setState({
                    uploadState: 0
                });
            } else {
                this.setState({
                    uploadState: 2
                });
            }
            // if (unDoneNum === totalNum) {
            //     //文件全没上传,开始
            //     this.setState({
            //         uploadState: 0,
            //     });
            // } else if (completedNum === totalNum) {
            //     //全已上传完毕，查看我的申请
            //     this.setState({
            //         uploadState: 2
            //     });
            // } else {
            //     //部分上传，继续
            //     this.setState({
            //         uploadState: 1,
            //         isUploadPanel: true
            //     });
            // }
        }
        
    };
    // 获得page status
    pageUploadStatus = ({ applicationInfo }) => {
        let allArr = [];
        let unDoneArr = [];
        let doneArr = [];
        let unDoneAndinComplete = [];
        let uploadList = [];
        if (applicationInfo) {
            const dataS004 = findQuestionById(applicationInfo, 'S004');
            dataS004 && dataS004.questions.map((item) => {
                if (documentCheckListQuestionShouldDisplay(applicationInfo, item)) {
                    const { questionIndicator, condition } = item;
                    const questionStatus = parseInt(item.questionStatus, 10);
                    uploadList.push(item);
                    if (questionIndicator === 'MenuOtherDocFile' || questionIndicator === 'MenuOtherDocFileOff') {
                        if (item.subQuestions && item.subQuestions.length === 1 &&
                            questionStatus === 0) {
                            // 其它文件-不显示
                            this.setState({ addBtnStatus: true });
                        } else {
                            this.setState({ addBtnStatus: false });
                        }
                    }
                    if (!JSON.parse(condition).mandatory || questionStatus === 1 || questionStatus === 3) {
                        allArr.push(item.questionIndicator);
                        if (questionStatus === 0) {
                             //后台返回，文件未上传
                            unDoneArr.push(questionIndicator);
                        } else if (questionStatus === 2) {
                            //后台返回，文件已上传成功
                            doneArr.push(questionIndicator);
                        }
                    }
                    if (questionStatus !== 2) {
                        //后台返回，文件未上传或未上传成功
                        unDoneAndinComplete.push(questionIndicator);
                    }
                }
            });
        }
        this.setState({ uploadList });
        return {
            allPageArr: allArr,
            donePageArr: doneArr,
            unDonePageArr: unDoneArr,
            unDoneFirstId: unDoneAndinComplete[0]
        };
    };
    pageCompanyStatus = ({ applicationInfo }) => {
        let completedNum = 0;
        let totalNum = 0;
        let unDonePageArr = [];
        let unDoneAndinComplete = [];
        if (applicationInfo) {
            const aoFormList = findQuestionById(applicationInfo, 'S003');
            totalNum = aoFormList.questions.length;
            aoFormList.questions.map((form) => {
                const questionStatus = parseInt(form.questionStatus, 10);
                if (questionStatus === 2) {
                    completedNum++;
                }
                if (questionStatus === 0) {
                    unDonePageArr.push(form.questionId);
                }
                if (questionStatus === 0 || questionStatus === 1) {
                    unDoneAndinComplete.push(form.questionId);
                }
            });
            const fList = aoFormList.questions.filter((item, index) => index < 5 );
            this.setState({ aoFormList: [...fList, aoFormList.questions[6], aoFormList.questions[5]] });
            // this.setState({ aoFormList: aoFormList.questions });
        }
        return {
            completedNum,
            totalNum,
            unDonePageArr,
            unDoneFirstId: unDoneAndinComplete[0]
        }
    };
    handelInformationItem(event, state) {
        event.preventDefault();
        const { isCompanyPanel } = this.state;
        const { unDoneFirstId } = this.pageCompanyStatus(this.props);
        switch (state) {
            case 0:
                {
                    clearInterval(this.timeInterval);
                    // 开始
                    history.push(paths.aoform.path('Q003-001'));
                    break;
                }
            case 1:
                {
                    clearInterval(this.timeInterval);
                    // 继续
                    history.push(paths.aoform.path(unDoneFirstId));
                    break;
                }
            case 2:
                {// 展开
                    this.trarkEventTag(event);
                    this.setState({ isCompanyPanel: !isCompanyPanel });
                    break;
                }
            default:
                { break; }
        }

    }
    handelUploadItem(event, state) {
        event.preventDefault();
        const { isUploadPanel } = this.state;
        const { unDonePageArr, unDoneFirstId } = this.pageUploadStatus(this.props);
        if (this.dummy && !this.props.isSkipUpload) {
            this.trarkEventTag(event);
            this.setState({ isUploadPanel: !isUploadPanel });
        } else {
            switch (state) {
                case 0: // status: start
                    {
                        clearInterval(this.timeInterval);
                        history.push(paths.file_upload_info.path(unDoneFirstId));
                        break;
                    }
                case 1: // status: Continue
                    {
                        clearInterval(this.timeInterval);
                        history.push(paths.file_upload_info.path(unDoneFirstId));
                        break;
                    }
                case 2: // status: Review my Application
                    {
                        this.trarkEventTag(event);
                        this.setState({ isUploadPanel: !isUploadPanel });
                        break;
                    }
                default:
                    break;
            }
        }
    }
    trarkEventTag = (event) => {
        const tag = event.target.getAttribute('data-eventtag');
        trackEvent(tag);
    }
    handelSubmitApplication(event) {
        event.preventDefault();
        clearInterval(this.timeInterval);
        const { i18n } = this.state;
        //再次判断是否全部upload都已经上传
        let isNextStep = true;
        if (!this.dummy) { //the skip function of upload document)
            const { uploadFiles } = this.props.businessInfo;
            uploadFiles && Object.keys(uploadFiles).forEach(item => {
                if (uploadFiles[item] && uploadFiles[item].status !== "SAVED") {
                    // isNextStep = false; // hide upload
                    isNextStep = true;
                }
            });
        }
        if (isNextStep) {
            const { status } = this.props.applicationInfo;
            if (status === 1) {
                history.push(paths.agreement.path);
            } else if (status === 4) {
                this.props.sumbitApplication()
                    .then(res => {
                    })
                    .catch(error => {
                    });
            }
        } else {
            alert(i18n.refresh);
        }
        
    }

    handleI18ntoView = ({ i18n, companyState, uploadState, isCompanyPanel, isUploadPanel }, isSkipUpload) => {
        let informationContent, uploadContent, submitContent;
        if (i18n) {
            const informationBtnText1 = (companyState === 2) ? i18n.button.review : (companyState === 1) ? i18n.button.continue : i18n.button.start;
            const informationBtnText2 = (uploadState === 2) ? i18n.button.review : (uploadState === 1) ? i18n.button.continue : i18n.button.start;
            informationContent = {
                contentOnly: {
                    title: i18n.company.title,
                    dataKey: "companyTitle",
                },
                info: {
                    text: i18n.company.subTitle,
                    dataKey: "companyText",
                },
                panelHeadButton: {
                    text: informationBtnText1,
                    dataKey: "PanelHeadButton1",
                    dataEvent: "DashboardReview"
                },
                panelBodyButton: {
                    text: i18n.button.complete,
                    dataKey: "companyCompleteReview",
                    dataEvent: "DashboardComplete"
                },
                state: companyState,
                isDisable: false,
                isPanel: isCompanyPanel
            };
            uploadContent = {
                contentOnly: {
                    title: i18n.upload.title,
                    dataKey: "uploadTitle",
                },
                info: {
                    text: i18n.upload.subTitle,
                    dataKey: 'uploadText',
                },
                panelHeadButton: {
                    text: informationBtnText2,
                    dataKey: "PanelHeadButton2",
                    dataEvent: "DashboardReview"
                },
                panelBodyButton: {
                    text: i18n.button.complete,
                    dataKey: "uploadCompleteReview",
                    dataEvent: "DashboardComplete"
                },
                skipButton: {
                    text: i18n.button.skip,
                    dataKey: "skipButton",
                },
                msgBox: {
                    title: {
                        text: i18n.msgBox.title,
                        dataKey: "msgBoxTitle"
                    },
                    info: {
                        text: i18n.msgBox.subTitle,
                        dataKey: "msgBoxInfo"
                    }
                },
                state: uploadState,
                isDisable: !(companyState === 2),
                isPanel: isUploadPanel
            };
            submitContent = {
                contentOnly: {
                    title: i18n.submit.title,
                    dataKey: "submitTitle",
                },
                info: {
                    text: i18n.submit.subTitle,
                    dataKey: "submitSubTitle",
                },
                panelHeadButton: {
                    text: i18n.button.submit,
                    dataKey: "SubmitApplicationButton",
                },
                isDisable: !(companyState === 2)
                // isDisable: !((uploadState === 2) && (companyState === 2)) // hide upload
            };
        }
        return {
            informationContent,
            uploadContent,
            submitContent
        }
    };

    handelCardItem = (event, questionId) => {
        event.preventDefault();
        clearInterval(this.timeInterval);
        history.push(paths.aoform.path(questionId));
    };
    handelUploadList = (event, questionId, questionIndicator) => {
        event.preventDefault();
        clearInterval(this.timeInterval);
        history.push(paths.file_upload_info.path(questionIndicator));
    };
    handelSkipUpload = (event) => {
        event.preventDefault();
        this.props.skipUploadAction({isSkipUpload: false})
    }
    onAddAction(event) {
        event.preventDefault();
        this.setState({ addBtnStatus: false });

    }
    // render
    render() {
        const { selectedLanguage, isSkipUpload, pageTitle } = this.props;
        const { i18n, aoFormList, uploadList, addBtnStatus } = this.state;
        const { informationContent, uploadContent, submitContent } = this.handleI18ntoView(this.state, isSkipUpload);

        if (i18n && pageTitle) {
          setTitle( i18n.title + pageTitle);
        }

        return (i18n && aoFormList) ? (
            <Grid className="dynamic-form ao-form ao-form-review">
                <AOForm.FormTitle
                    content={{
                        title: {
                            text: i18n.title,
                            dataKey: "aoFormReviewTitle",
                        },
                        subTitle: {
                            text: i18n.subTitle,
                            dataKey: "aoFormReviewSubTitle"
                        }
                    }}
                />

                <PanelGroup >
                    <LocalComponent.PanelGroupReview
                        content={informationContent}
                        handelHead={this.handelInformationItem}
                        className={'information'}
                        index={1}
                    >
                        <LocalComponent.AOFormList
                            aoFormList={aoFormList}
                            i18n={i18n}
                            selectedLanguage={selectedLanguage}
                            handelCardItem={this.handelCardItem}
                        />
                    </LocalComponent.PanelGroupReview>

                    {/* <LocalComponent.PanelGroupReview
                        content={uploadContent}
                        handelHead={this.handelUploadItem}
                        handelSkipUpload={this.handelSkipUpload}
                        isSkipUpload={isSkipUpload}
                        dummy = {this.dummy}
                        className={'upload'}
                        index={2}
                    >
                        <LocalComponent.UploadList
                            addBtnStatus={addBtnStatus}
                            uploadList={uploadList}
                            i18n={i18n}
                            selectedLanguage={selectedLanguage}
                            handelUploadList={this.handelUploadList}
                        />

                        <LocalComponent.UploadAddButton
                            addBtnText={{
                                text: i18n.uploadAddBtnText,
                                dataKey: 'aoFormReview.uploadAddBtnText'
                            }}
                            addBtnStatus={this.state.addBtnStatus}
                            onAddAction={this.onAddAction}
                        />

                    </LocalComponent.PanelGroupReview> */}

                    <LocalComponent.PanelGroupReview
                        content={submitContent}
                        handelHead={this.handelSubmitApplication}
                        className={'determine'}
                        index={3}
                    >
                    </LocalComponent.PanelGroupReview>
                </PanelGroup>
            </Grid>
        ) : null;
    }
}


AOFormReviewContainer.propTypes = {
    formJson: PropTypes.string,
};

AOFormReviewContainer.defaultProps = {
    params: {
        companyState: 0, //0 start, 1 continue, 2 complete
        uploadState: 0,
        isCompanyPanel: false,
        isUploadPanel: false,
        addBtnStatus: true
    }
};

const mapStateToProps = (state) => ({
    applicationInfo: state.app.applicationInfo,
    selectedLanguage: state.app.selectedLanguage,
    businessInfo: state.app.businessInfo,
    isSkipUpload: state.dashboard.isSkipUpload,
    pageTitle: state.app.i18n.pageTitle
});

export default connect(mapStateToProps, {
    updateStep,
    sumbitApplication,
    getStatusFile,
    saveUploadBusiness,
    skipUploadAction
})(AOFormReviewContainer);



// WEBPACK FOOTER //
// ./src/views/AOFormReview/container/index.js